/**
 * Drop-in replacement for Gatsby's internal `.cache/strip-prefix.js`.
 * It preserves Gatsby's behavior and handles a query or hash immediately
 * after pathPrefix when the public URL has no trailing slash.
 */
export default function stripPrefix(str, prefix = ``) {
  if (!prefix) {
    return str;
  }

  if (str === prefix) {
    return `/`;
  }

  if (str.startsWith(`${prefix}/`)) {
    return str.slice(prefix.length);
  }

  if (str.startsWith(`${prefix}?`) || str.startsWith(`${prefix}#`)) {
    return `/${str.slice(prefix.length)}`;
  }

  return str;
}
